import React, { useEffect, Fragment } from 'react';
import { Switch, Route } from "react-router-dom";

// Pages
import HomeScreen from "./pages/home/HomeScreen";
import CreateNFTs from "./pages/createNFT/CreateNFTs";
import About from "./pages/about/About";
import SingleNFT from "./pages/eachNFT/SingleNFT";
import SingleNFTInfluencer from "./pages/eachNFT/SingleNFTInfluencer";
import PrivacyPolicy from "./pages/privacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./pages/termsAndConditions/TermsAndConditions";

import Fav from "./pages/favourites/Fav";
import ExploreNFTs from "./pages/exploreNFT/ExploreNFTs";
import Profile from "./pages/profile/Profile";
import SearchProfile from "./pages/profile/SearchProfile";
import ScrollToTop from "./ScrollToTop"

import {connect, useSelector} from "react-redux";

import { acc } from "./components/header/wallet/WalletPopup";
import {authFeatureKey} from "./store/featureKeys";

function Routes({ account }) {
  console.log(acc);
    const {currentUser} = useSelector(state=>{
        return state[authFeatureKey]
    })
  return (
    <Fragment>
      <ScrollToTop />
      <Switch>
        <Route exact path="/" component={HomeScreen} />
        <Route exact path="/createnft" component={CreateNFTs} />
        {/*<Route exact path="/singlenft/:nft/:influencer" component={SingleNFT} />*/}
        {/*<Route exact path="/:ipfsHash" component={} />*/}
        {currentUser && <Route exact path="/favourites" component={Fav} />}
        <Route exact path="/explore" component={ExploreNFTs} />
        <Route exact path="/explore/:ipfsHash" component={SingleNFT} />
        {currentUser && <Route exact path="/profile/" component={Profile} />}
        { <Route exact path="/profile/:id" component={SearchProfile} />}      
        <Route exact path="/explore/:ipfsHash/:influencer" component={SingleNFTInfluencer} />
        <Route exact path="/explore/:ipfsHash/:influencer" component={SingleNFTInfluencer} />
        <Route exact path="/about" component={About} />
        <Route exact path="/privacy-policy" component={PrivacyPolicy} />
        <Route exact path="/terms-and-conditions" component={TermsAndConditions} />
      </Switch>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return { account: state.currentUser };
};

export default connect(mapStateToProps)(Routes);
